import * as React from 'react';
import { RequestConstants } from '../../../../models/constants/constants';
import {
  FreelanceRequest,
  RequestPropertyKey,
  RequestSeverity,
  RequestUIState,
} from '../../models/requestModels';
import {
  getAcknowledgeDateTime,
  getClosedDateTime,
  getCreateDateTime,
  getSeverity,
  getUIState,
} from '../../reduxUpdater/selectors/requestSelector';
import { IContactUsStyles } from '../../styles/contactUsStyles';
import { IStyledComponent } from '../../styles/themesUI';
import { getString } from '../../../../../web/utils/stringLoader';

interface IRequestPropertyComponentProps {
  requestPropertyKey: RequestPropertyKey;
  request: FreelanceRequest;
}

type IRequestPropertyProps = IRequestPropertyComponentProps & IStyledComponent<IContactUsStyles>;

export class RequestProperty extends React.PureComponent<IRequestPropertyProps> {
  public render(): React.ReactNode {
    let stringToRender = String();
    let ariaLabel = '';
    switch (this.props.requestPropertyKey) {
      case RequestPropertyKey.State:
        stringToRender = this.getStateText();
        ariaLabel = this.getStateAriaLabel();
        break;
      case RequestPropertyKey.CreateDateTime:
        const createDateTime = getCreateDateTime(this.props.request);
        stringToRender = this.getDateTimeText(createDateTime);
        break;
      case RequestPropertyKey.AcknowledgeDateTime:
        const acknowledgeDateTime = getAcknowledgeDateTime(this.props.request);
        stringToRender = this.getDateTimeText(acknowledgeDateTime);
        break;
      case RequestPropertyKey.ClosedDateTime:
        const closedDateTime = getClosedDateTime(this.props.request);
        stringToRender = this.getDateTimeText(closedDateTime);
        break;
      case RequestPropertyKey.Severity:
        stringToRender = this.getSeverityText();
        break;
      default:
        break;
    }

    return <span aria-label={ariaLabel}>{stringToRender}</span>;
  };

  private getStateText = (): string => {
    const uIState = getUIState(this.props.request);
    return getString(`requestUIState_${RequestUIState[uIState]}_Label`);
  };

  private getStateAriaLabel = (): string => {
    const uIState = getUIState(this.props.request);
    return getString(`requestUIState_${RequestUIState[uIState]}_AriaLabel`);
  };

  private getDateTimeText = (dateTime: Date): string => {
    if (!!dateTime) {
      const dateString = dateTime.toLocaleDateString();
      const timeString = dateTime.toLocaleTimeString([], {
        hour: RequestConstants.DateTimeFormat as any,
        minute: RequestConstants.DateTimeFormat as any,
      });
      return getString('requestDetails_dateTimeString')
        .replace('{0}', dateString)
        .replace('{1}', timeString);
    } else {
      return String();
    }
  };

  private getSeverityText = (): string => {
    const severity = getSeverity(this.props.request);
    if (severity === RequestSeverity.None) {
      return String();
    } else {
      return getString(`requestSeverity_${RequestSeverity[severity]}`);
    }
  };
}
